module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 746
// module chunks = 81